import SubscriptionDetailsContainer from './SubscriptionDetailsContainer';
import SubscriptionDetailsStore from "./SubscriptionDetailsStore";

export default SubscriptionDetailsStore(SubscriptionDetailsContainer);